import { decode } from 'shopify-gid'
import { getShopifyData } from '../../utils'
import Cookies from 'js-cookie'

// custom event
// Caspar asked to untrack this event to make Segment more affordable
export const useCollectionPageViewedTracking = (props) => {
  // const { currency, locale, name, verticals, products } = props
  // const fbc = Cookies.get('_fbc')
  // const fbp = Cookies.get('_fbp')
  // if (typeof window !== 'undefined' && window.analytics) {
  //   window.analytics.track('Collection Page Viewed', {
  //     currency,
  //     value: 0,
  //     locale,
  //     category: products.map(
  //       (product) => decode(getShopifyData(product, locale).shopifyId)?.id,
  //     ), // client request to be a list of product IDs
  //     name,
  //     verticals: verticals,
  //     brand: 'Stox',
  //     branch: window?.phill?.BRANCH,
  //     products: products.map(
  //       ({
  //         title: productTitle,
  //         shopifyProduct,
  //         slug,
  //         thumbnailImage,
  //         shopifyData,
  //         shopifyDataUs,
  //       }) => ({
  //         name: productTitle,
  //         price: shopifyProduct.variants.edges[0].node.price,
  //         id: decode(
  //           getShopifyData({ shopifyData, shopifyDataUs }, locale).shopifyId,
  //         )?.id,
  //         currency: 'EUR',
  //         brand: 'Stox',
  //         category: 'Socks',
  //         slug: `/${locale}/${slug}/`,
  //         image_url: 'https:' + thumbnailImage.file.url,
  //       }),
  //     ),
  //     action_source: "website",
  //     fbc: fbc || null,
  //     fbp: fbp || null
  //   })
  // }
}
